/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_VietnameseInputs */

const en_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vietnamese`)
};

const fr_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vietnamien`)
};

const de_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vietnamesisch`)
};

const it_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vietnamita`)
};

const ru_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`вьетнамский`)
};

const es_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vietnamita`)
};

const zh_cn2_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`越南语`)
};

const ja_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベトナム語`)
};

const hi_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वियतनामी`)
};

const pt_pt2_speechmatics_target_language_vietnamese = /** @type {(inputs: Speechmatics_Target_Language_VietnameseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vietnamita`)
};

/**
* | output |
* | --- |
* | "Vietnamese" |
*
* @param {Speechmatics_Target_Language_VietnameseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_vietnamese = /** @type {((inputs?: Speechmatics_Target_Language_VietnameseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_VietnameseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_vietnamese(inputs)
	if (locale === "de") return de_speechmatics_target_language_vietnamese(inputs)
	if (locale === "it") return it_speechmatics_target_language_vietnamese(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_vietnamese(inputs)
	if (locale === "es") return es_speechmatics_target_language_vietnamese(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_vietnamese(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_vietnamese(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_vietnamese(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_vietnamese(inputs)
	return en_speechmatics_target_language_vietnamese(inputs)
});